let productSelectionButtonClicked = false,
  productSelectionIndex,
  selectedProducts = []; // shared across all bundles now
const getTotalSelectedQuantity = () => selectedProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);

function unselectAllPresetButtons() {
  document.querySelectorAll(".preset-bundle-button").forEach((button) => {
    button.classList.remove("active");
  });
}

const buildSelectedProductArray = (trigger) => {
  const method = trigger.classList.contains("lsg-bundle-product-select-quantity-minus")
    ? "minus"
    : trigger.classList.contains("lsg-bundle-product-select-quantity-plus")
      ? "plus"
      : "err";
  const triggeredProductWrapper = trigger.closest(".lsg-bundle-product-select-wrapper");
  const variantID = triggeredProductWrapper.getAttribute("data-lsg-bundle-variant-select-id");
  const productTitle = triggeredProductWrapper.querySelector(".lsg-bundle-product-select-title").innerHTML;

  switch (method) {
    case "minus":
      const existingIndex = selectedProducts.findIndex((p) => p.selectedVariantId === variantID);
      if (existingIndex > -1) {
        if (selectedProducts[existingIndex].quantity > 1) {
          selectedProducts[existingIndex].quantity -= 1;
        } else {
          selectedProducts.splice(existingIndex, 1);
        }
        unselectAllPresetButtons(); // Unselect preset buttons when a product is removed
      }
      productSelectionButtonClicked = false;

      // Check if all items are removed and remove the mobile drawer class
      if (selectedProducts.length === 0) {
        const bundleBlock = document.querySelector(".lsg-bundle-block");
        if (bundleBlock) {
          bundleBlock.classList.remove("mobile-bundle-drawer--opened");
        }
      }
      break;
    case "plus":
      const productImageUrl = triggeredProductWrapper.querySelector("img").src;
      const productImageAlt = triggeredProductWrapper.querySelector("img").alt;
      const existing = selectedProducts.find((p) => p.selectedVariantId === variantID);

      // Before adding the item, check if we need to switch bundle size
      const currentCount = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);
      const currentBundle = document.querySelector('.bundle-option input[name="label"]:checked');

      if (currentBundle) {
        const currentBundleSize = parseInt(
          currentBundle.closest(".bundle-option").querySelector(".panel-body").textContent,
        );

        // If adding one more would exceed the current bundle size
        if (currentCount + 1 > currentBundleSize) {
          // Find the next larger bundle size
          const bundleOptions = Array.from(document.querySelectorAll('.bundle-option input[name="label"]'))
            .map((radio) => ({
              radio,
              size: parseInt(radio.closest(".bundle-option").querySelector(".panel-body").textContent),
            }))
            .sort((a, b) => a.size - b.size);

          const nextBundle = bundleOptions.find((opt) => opt.size > currentBundleSize);
          if (nextBundle) {
            nextBundle.radio.click();
          }
        }
      }

      if (existing) {
        existing.quantity += 1;
      } else {
        selectedProducts.push({
          selectedProductImageUrl: productImageUrl,
          selectedVariantId: variantID,
          selectedProductTitle: productTitle,
          selectedProductImageAlt: productImageAlt,
          quantity: 1,
        });
      }
      break;
  }

  updateSelectedProductGUI(trigger);
};

const updateSelectedProductGUI = () => {
  const wrapper = document.querySelector("[data-bundle-builder-selected-products]");
  const noSelections = wrapper.querySelector("[data-bundle-builder-no-selections]");

  // Clear existing entries
  wrapper.querySelectorAll("[data-bundle-builder-selected-variant-id]").forEach((el) => el.remove());

  if (selectedProducts.length === 0) {
    noSelections.classList.remove("tw:hidden");
    document.querySelectorAll(".lsg-bundle-block").forEach((block) => block.classList.remove("has-selected-product"));
    updateBundleTracker();
    return;
  }

  noSelections.classList.add("tw:hidden");
  document.querySelectorAll(".lsg-bundle-block").forEach((block) => block.classList.add("has-selected-product"));

  selectedProducts.forEach((product, i) => {
    const wrapperDiv = document.createElement("div");
    wrapperDiv.classList.add("bundle-builder__selected-product", "active");
    wrapperDiv.dataset.bundleBuilderSelectedVariantId = product.selectedVariantId;
    wrapperDiv.dataset.index = i;

    const productWrapper = document.createElement("div");
    productWrapper.classList.add("bundle-builder__selected-product-wrapper");

    const imgWrapper = document.createElement("div");
    imgWrapper.classList.add("bundle-builder__selected-product-img-wrapper");
    const img = document.createElement("img");
    img.classList.add("bundle-builder__selected-product-image");
    img.dataset.bundleBuilderSelectedProductImage = "";
    img.src = product.selectedProductImageUrl;
    img.alt = product.selectedProductImageAlt;
    imgWrapper.appendChild(img);

    const titleWrap = document.createElement("div");
    titleWrap.classList.add("bundle-builder__selected-product-title-wrap");

    const title = document.createElement("span");
    title.classList.add("bundle-builder__selected-product-title");
    title.dataset.bundleBuilderSelectedProductTitle = "";
    title.innerHTML = product.selectedProductTitle;

    const qtyControls = document.createElement("div");
    qtyControls.classList.add("bundle-builder__selected-product-qty-controls");

    const minusBtn = document.createElement("button");
    minusBtn.classList.add("bundle-builder__qty-minus");
    minusBtn.setAttribute("aria-label", "Decrease quantity");
    minusBtn.innerHTML = `
        <svg aria-labelledby="minusIconTitle" width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.375 10.999C18.375 11.1731 18.3059 11.34 18.1828 11.4631C18.0597 11.5861 17.8928 11.6553 17.7187 11.6553H3.28125C3.1072 11.6553 2.94028 11.5861 2.81721 11.4631C2.69414 11.34 2.625 11.1731 2.625 10.999C2.625 10.825 2.69414 10.6581 2.81721 10.535C2.94028 10.4119 3.1072 10.3428 3.28125 10.3428H17.7187C17.8928 10.3428 18.0597 10.4119 18.1828 10.535C18.3059 10.6581 18.375 10.825 18.375 10.999Z" fill="#414E50"/>
        </svg>`;
    minusBtn.addEventListener("click", () => {
      const bundleBlock = document
        .querySelector(`[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"]`)
        ?.closest(".lsg-bundle-block");
      const minus = bundleBlock?.querySelector(
        `[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"] .lsg-bundle-product-select-quantity-minus`,
      );
      if (minus) minus.click();
    });

    const qtyText = document.createElement("span");
    qtyText.textContent = `${product.quantity}`;
    qtyText.classList.add("bundle-builder__selected-product-quantity");

    const plusBtn = document.createElement("button");
    plusBtn.classList.add("bundle-builder__qty-plus");
    plusBtn.setAttribute("aria-label", "Increase quantity");
    plusBtn.innerHTML = `
        <svg aria-labelledby="plusIconTitle"  width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.375 10.999C18.375 11.1731 18.3059 11.34 18.1828 11.4631C18.0597 11.5861 17.8928 11.6553 17.7187 11.6553H11.1562V18.2178C11.1562 18.3918 11.0871 18.5587 10.964 18.6818C10.841 18.8049 10.674 18.874 10.5 18.874C10.326 18.874 10.159 18.8049 10.036 18.6818C9.91289 18.5587 9.84375 18.3918 9.84375 18.2178V11.6553H3.28125C3.1072 11.6553 2.94028 11.5861 2.81721 11.4631C2.69414 11.34 2.625 11.1731 2.625 10.999C2.625 10.825 2.69414 10.6581 2.81721 10.535C2.94028 10.4119 3.1072 10.3428 3.28125 10.3428H9.84375V3.78027C9.84375 3.60623 9.91289 3.43931 10.036 3.31623C10.159 3.19316 10.326 3.12402 10.5 3.12402C10.674 3.12402 10.841 3.19316 10.964 3.31623C11.0871 3.43931 11.1562 3.60623 11.1562 3.78027V10.3428H17.7187C17.8928 10.3428 18.0597 10.4119 18.1828 10.535C18.3059 10.6581 18.375 10.825 18.375 10.999Z" fill="#414E50"/>
        </svg>
      `;
    plusBtn.addEventListener("click", () => {
      const bundleBlock = document
        .querySelector(`[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"]`)
        ?.closest(".lsg-bundle-block");
      const plus = bundleBlock?.querySelector(
        `[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"] .lsg-bundle-product-select-quantity-plus`,
      );
      if (plus) plus.click();
    });

    qtyControls.appendChild(minusBtn);
    qtyControls.appendChild(qtyText);
    qtyControls.appendChild(plusBtn);

    titleWrap.appendChild(title);
    titleWrap.appendChild(qtyControls);

    productWrapper.appendChild(imgWrapper);
    productWrapper.appendChild(titleWrap);
    wrapperDiv.appendChild(productWrapper);
    wrapper.appendChild(wrapperDiv);
  });

  updateBundleTracker();
};

function checkParameter() {
  const bundleBlock = document.querySelector(".lsg-bundle-block");
  if (!bundleBlock) return;

  const urlParams = new URLSearchParams(window.location.search);
  const queryString = window.location.search;

  const bundles = urlParams.getAll("bundle");
  const bundle_interval = urlParams.getAll("bundle_interval");
  const bundle_interval_frequency = urlParams.getAll("bundle_interval_frequency");

  if (bundles.length > 0 || bundle_interval.length > 0 || bundle_interval_frequency.length > 0) {
    // Load product selections
    bundles.forEach((el) => {
      const [id, quantity] = el.split("_");
      const quantityInput = bundleBlock.querySelector(
        `.lsg-bundle-product-select-quantity-input[data-product="${id}"]`,
      );
      if (quantityInput) {
        quantityInput.value = parseInt(quantity, 10) - 1;
        const plusBtn = quantityInput
          .closest(".lsg-bundle-product-select-quantity-wrap")
          ?.querySelector(".lsg-bundle-product-select-quantity-plus");
        for (let i = 0; i < quantity; i++) {
          quantityInput.value = i;
          incrementSubProduct(plusBtn);
          buildSelectedProductArray(plusBtn);
          incrementEnableValidation(plusBtn);
          checkoutEnableValidation();
        }
      }
    });

    // Load interval (OTP / Subscription)
    if (bundle_interval.length > 0) {
      const selectedIntervalInput = bundleBlock.querySelector(
        `.lsg-bundle-interval-select input[name^="bundle_interval_select_"][value="${bundle_interval[0]}"]`,
      );
      if (selectedIntervalInput) {
        selectedIntervalInput.checked = true;
        updateInterval(selectedIntervalInput);
        checkoutEnableValidation();
      }
    }

    // Load subscription frequency
    if (bundle_interval_frequency.length > 0) {
      const frequencySelect = bundleBlock.querySelector(".lsg-bundle-interval-frequency-select");
      if (frequencySelect) {
        frequencySelect.value = bundle_interval_frequency[0];
        updateFrequency(frequencySelect);
      }
    }

    // Clean URL in history
    if (history.pushState) {
      const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      history.pushState({ path: newurl }, "", newurl);
    }
  }
}

function setUrl() {
  const bundleBlockWrapper = document.querySelector(".lsg-bundle-wrapper");
  if (bundleBlockWrapper && !bundleBlockWrapper.hasAttribute("data-lsg-bundle-set-url")) {
    return false;
  }
  const bundleBlock = getBundleBlock();
  const quantityInput = bundleBlock.querySelectorAll(".lsg-bundle-product-select-quantity-input");
  let url = "?";
  let paramName = "bundle";
  quantityInput.forEach((el) => {
    const value = el.value;
    if (value > 0) {
      url += url == "?" ? "" : "&";
      url += `${paramName}=${el.getAttribute("data-product")}_${value}`;
    }
  });
  const selectedBundle = bundleBlock
    .closest(".lsg-bundle-wrapper")
    .querySelector(".lsg-bundle-block.lsg-bundle-block-active");
  if (selectedBundle != null) {
    paramName = "bundle_index";
    url += url == "?" ? "" : "&";
    url += `${paramName}=${Array.from(selectedBundle.parentNode.children).indexOf(selectedBundle)}`;
  }
  const bundleIntervalOption = bundleBlock.querySelector('.lsg-bundle-interval-select input[type="radio"]:checked');
  if (bundleIntervalOption != null) {
    paramName = "bundle_interval";
    url += url == "?" ? "" : "&";
    url += `${paramName}=${bundleIntervalOption.value}`;
    if (bundleIntervalOption.value == "sub") {
      paramName = "bundle_interval_frequency";
      url += url == "?" ? "" : "&";
      const bundleIntervalFrequencySelect = bundleBlock.querySelector(".lsg-bundle-interval-frequency-select");
      if (bundleIntervalFrequencySelect != null) {
        url += `${paramName}=${bundleIntervalFrequencySelect.value}`;
      }
    }
  }
  if (history.pushState) {
    var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + url;
    window.history.pushState({ path: newurl }, "", newurl);
  }
}

function incrementEnableValidation(trigger) {
  const productSetList = trigger.closest(".lsg-bundle-product-set-list");
  const quantityIncrementButtons = productSetList.querySelectorAll(".lsg-bundle-product-select-quantity-increment");
  const quantityInputs = productSetList.querySelectorAll(".lsg-bundle-product-select-quantity-input");
  const bundleBlock = getBundleBlock();
  const bundleQuantity = getBundleQuantityByChild(trigger);
  const bundleMax = parseInt(productSetList.dataset.bundleMax) || 0;
  const overallMax = parseInt(bundleBlock.querySelector(".lsg-bundle-tracker-bar").dataset.bundleMax) || 12;

  // Add/remove bundle-max-reached class
  if (bundleQuantity >= overallMax) {
    bundleBlock.classList.add("bundle-max-reached");
  } else {
    bundleBlock.classList.remove("bundle-max-reached");
  }

  quantityIncrementButtons.forEach((button) => {
    const method = button.classList.contains("lsg-bundle-product-select-quantity-minus")
      ? "minus"
      : button.classList.contains("lsg-bundle-product-select-quantity-plus")
        ? "plus"
        : "err";
    const wrap = button.closest(".lsg-bundle-product-select-quantity-wrap");
    const input = wrap.querySelector(".lsg-bundle-product-select-quantity-input");
    const quantity = parseInt(input.value) || 0;

    switch (method) {
      case "minus":
        button.disabled = quantity <= 0 || quantity <= parseInt(input.min);
        input.disabled = button.disabled;
        break;
      case "plus":
        button.disabled = quantity >= parseInt(input.max) || (bundleMax > 0 && bundleQuantity >= bundleMax);
        input.disabled = button.disabled;
        break;
    }
  });

  quantityInputs.forEach((input) => {
    const quantity = parseInt(input.value) || 0;
    input.disabled = quantity >= parseInt(input.max) || (bundleMax > 0 && bundleQuantity >= bundleMax) || quantity <= 0;
  });

  // Update summary section buttons
  const summaryPlusButtons = bundleBlock.querySelectorAll(".bundle-builder__qty-plus");
  summaryPlusButtons.forEach((button) => {
    button.disabled = bundleQuantity >= overallMax;
  });
}

function updateUpsellMessage() {
  const bundleBlock = getBundleBlock();
  const bundleQuantity = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);
  const upsellMessage = bundleBlock.querySelector(".lsg-bundle-upsell-status-message");
  const tracker = bundleBlock.querySelector(".lsg-bundle-tracker-bar");
  const maxBundle = parseInt(tracker.dataset.bundleMax, 10);

  // Find all tiers sorted by max
  const tiers = Array.from(document.querySelectorAll(".lsg-bundle-tracker-option"))
    .map((opt) => ({
      max: parseInt(opt.dataset.bundleMax, 10),
      productId: opt.dataset.bundleProductId,
    }))
    .filter((tier) => tier.max > 0) // Exclude 0
    .sort((a, b) => a.max - b.max);

  // Find the next bundle with a non-zero discount
  let targetTier = null;
  let discountValue = 0;
  let discountType = "";
  for (const tier of tiers) {
    if (tier.max <= bundleQuantity) continue; // Skip tiers at or below current quantity
    const wrap = bundleBlock.querySelector(
      `.lsg-bundle-interval-select-wrap[data-bundle-product-id="${tier.productId}"]`,
    );
    const frequencySelect = wrap?.querySelector(".lsg-bundle-interval-frequency-select option:checked");
    discountValue = parseInt(frequencySelect?.dataset.discountValue, 10) || 0;
    discountType = frequencySelect?.dataset.discountType || "";
    if (discountValue > 0) {
      targetTier = tier;
      break;
    }
  }

  // Update upsell message
  if (upsellMessage) {
    if (bundleQuantity >= maxBundle) {
      upsellMessage.innerHTML =
        "Your box is full! <span data-first-upsell-discount-number hidden></span><span data-first-upsell-discount-amount hidden></span>";
    } else if (targetTier) {
      const remaining = targetTier.max - bundleQuantity;
      let savings = 0;
      if (discountType === "percentage") {
        savings = (targetTier.max * 1600 * discountValue) / 100; // $16 per item
      } else if (discountType === "fixed_amount") {
        savings = discountValue * targetTier.max; // $2.67 per product * number of products
      }
      upsellMessage.innerHTML = `Add <span data-first-upsell-discount-number>${remaining}</span> more flavors and save <span data-first-upsell-discount-amount>$${(savings / 100).toFixed(2)}</span>`;
    } else {
      upsellMessage.innerHTML =
        "Select more flavors to save! <span data-first-upsell-discount-number hidden></span><span data-first-upsell-discount-amount hidden></span>";
    }
    upsellMessage.style.display = "block";
  }
}

function checkoutEnableValidation() {
  const bundleBlock = getBundleBlock();
  const addToCartButtons = bundleBlock.querySelectorAll("[data-lsg-bundle-atc]");
  const bundleQuantity = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);

  const matchedTier = Array.from(document.querySelectorAll(".lsg-bundle-tracker-option")).find(
    (opt) => parseInt(opt.dataset.bundleMax, 10) === bundleQuantity,
  );

  if (matchedTier) {
    const productIdInput = bundleBlock.querySelector('.lsg-bundle-form input[name="id"]');
    if (productIdInput && matchedTier.dataset.bundleProductId) {
      const oldValue = productIdInput.value;
      productIdInput.value = matchedTier.dataset.bundleProductId;

      if (oldValue !== matchedTier.dataset.bundleProductId) {
        setTimeout(() => {
          updateSellingPlan();
        }, 0);
      }
    }

    addToCartButtons.forEach((addToCartButton) => {
      const atcText = addToCartButton.querySelector("[data-lsg-bundle-submit-button-atc-text]");
      const addMoreText = addToCartButton.querySelector("[data-lsg-bundle-submit-button-add-more-text]");
      const addMoreQuantity = addToCartButton.querySelector("[data-lsg-bundle-submit-button-add-more-quantity]");

      addToCartButton.classList.remove("disabled");
      atcText?.classList.remove("tw:hidden");
      addMoreText?.classList.add("tw:hidden");
      bundleBlock.classList.add("bundle-checkout-enabled");

      document.querySelectorAll(".lsg-bundle-tracker-option").forEach((opt) => {
        opt.classList.toggle("active", opt === matchedTier);
      });

      document.querySelectorAll(".lsg-bundle-interval-select-wrap").forEach((wrapper) => {
        const isActive = wrapper.dataset.bundleProductId === matchedTier.dataset.bundleProductId;
        wrapper.setAttribute("data-active", isActive ? "true" : "false");
        wrapper.style.display = isActive ? "block" : "none";
      });
    });

    // Update price when milestone changes
    updateBundlePrice();
  } else {
    addToCartButtons.forEach((addToCartButton) => {
      const atcText = addToCartButton.querySelector("[data-lsg-bundle-submit-button-atc-text]");
      const addMoreText = addToCartButton.querySelector("[data-lsg-bundle-submit-button-add-more-text]");
      const addMoreQuantity = addToCartButton.querySelector("[data-lsg-bundle-submit-button-add-more-quantity]");

      addToCartButton.classList.add("disabled");
      atcText?.classList.add("tw:hidden");
      addMoreText?.classList.remove("tw:hidden");

      const nextTier = Array.from(document.querySelectorAll(".lsg-bundle-tracker-option"))
        .map((opt) => parseInt(opt.dataset.bundleMax, 10))
        .filter((q) => q > bundleQuantity)
        .sort((a, b) => a - b)[0];

      if (addMoreQuantity && nextTier) {
        addMoreQuantity.innerHTML = nextTier - bundleQuantity;
      }

      bundleBlock.classList.remove("bundle-checkout-enabled");
    });
  }
  updateUpsellMessage();
}

function addToCart(isOneTimePurchase = false) {
  const bundleID = getGuid();
  const bundleBlock = getBundleBlock();
  const bundleForm = bundleBlock.querySelector(".lsg-bundle-form");
  const matchedTier = document.querySelector(".lsg-bundle-tracker-option.active");
  const activeWrap = bundleBlock.querySelector('.lsg-bundle-interval-select-wrap[data-active="true"]');

  // Get selling plan from active wrap's data attribute if it's a subscription
  const bundleSellingPlan = isOneTimePurchase ? "" : activeWrap?.dataset.currentSellingPlan || "";
  const bundleProductID = matchedTier?.dataset.bundleProductId || bundleForm.querySelector('input[name="id"]').value;
  const interval = isOneTimePurchase ? "otp" : "sub";
  const bundleMin = interval === "otp" ? bundleBlock.dataset.otpBundleMin : bundleBlock.dataset.subBundleMin;
  const bundleMax = interval === "otp" ? bundleBlock.dataset.otpBundleMax : bundleBlock.dataset.subBundleMax;
  const bundleCart = {
    items: [],
  };

  // Add the main bundle parent product
  const bundleItem = {
    id: bundleProductID,
    quantity: 1,
    properties: {
      _bundleId: bundleID,
      _bundle_parent: true,
      _bundle_id: bundleID,
      _bundleType: interval,
    },
  };
  if (!isOneTimePurchase && bundleSellingPlan) {
    bundleItem.selling_plan = bundleSellingPlan;
  }
  bundleCart.items.push(bundleItem);

  // Add selected products
  let bundleProductQuantity = 0;
  selectedProducts.forEach((product) => {
    bundleProductQuantity += product.quantity;

    const item = {
      id: product.selectedVariantId,
      quantity: product.quantity,
      properties: {
        _bundleParentId: bundleID,
        _subscriptionDiscount: true,
        Box: true,
        _bundle_id: bundleID,
      },
    };

    if (!isOneTimePurchase && bundleSellingPlan) {
      item.selling_plan = bundleSellingPlan;
    }

    bundleCart.items.push(item);
  });

  // Validate bundle quantity
  if (bundleProductQuantity > bundleMax || bundleProductQuantity < bundleMin) {
    return false;
  }

  // Send to cart
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    body: JSON.stringify(bundleCart),
    credentials: "same-origin",
  })
    .then((response) => {
      if (response.status === 200) {
        // First refresh the cart contents
        window.refreshCartContents(response);

        // Close mobile summary if it's open
        const summaryBlock = document.querySelector(".lsg-bundle-summary-block");
        if (summaryBlock && summaryBlock.classList.contains("open")) {
          const closeSummary = () => {
            summaryBlock.classList.remove("open");
            if (bundleBlock) {
              bundleBlock.classList.remove("mobile-bundle-drawer--opened");
            }
            const activeTrigger = document.querySelector("[mobile-summary-open].active");
            if (activeTrigger) {
              activeTrigger.classList.remove("active");
            }
            window.mobileSummaryActiveTrigger = null;
            unlockScroll();
          };
          closeSummary();
        }

        // Then open the cart drawer using the theme's method
        // if (document.querySelector('#offcanvas-cart')) {
        //   bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart').show();
        // }
      }
    })
    .catch((error) => {
      console.error("Error adding bundle to cart:", error);
    });
}

function updateFrequency(trigger) {
  //Render price and assign selling_plan in the form
  updateBundlePrice();
  updateSellingPlan();
}

// Simple: show on SUB, hide on OTP
function toggleMobileSubscriptionChecklist() {
  const wrap = document.querySelector("[data-mobile-subscription-checklist]");
  const block = getBundleBlock && getBundleBlock();
  if (!wrap || !block) return;

  const isOTP = block.classList.contains("lsg-bundle--otp-selected");
  wrap.style.display = isOTP ? "none" : ""; // hide on OTP, show otherwise
}

function updateInterval(trigger) {
  const bundleBlock = getBundleBlock();
  const oneTimePurchaseBtn = document.getElementById("bundle-atc--one-time-purchase");
  const subscriptionBtn = bundleBlock.querySelector("[data-lsg-bundle-atc]");

  bundleBlock.classList.remove("lsg-bundle--otp-selected", "lsg-bundle--sub-selected");

  if (trigger.value === "otp") {
    bundleBlock.classList.add("lsg-bundle--otp-selected");
    if (oneTimePurchaseBtn) oneTimePurchaseBtn.style.display = "block";
    if (subscriptionBtn) subscriptionBtn.style.display = "block";
  } else {
    bundleBlock.classList.add("lsg-bundle--sub-selected");
    if (oneTimePurchaseBtn) oneTimePurchaseBtn.style.display = "none";
    if (subscriptionBtn) subscriptionBtn.style.display = "block";
  }

  // ⬇️ add this line
  toggleMobileSubscriptionChecklist();

  // Dispatch event for belly band visibility updates
  const intervalChangedEvent = new CustomEvent("lsg:interval-changed", {
    bubbles: true,
    detail: { interval: trigger.value },
  });
  bundleBlock.dispatchEvent(intervalChangedEvent);
  document.dispatchEvent(intervalChangedEvent);

  updateBundlePrice();
  updateSellingPlan();
}

// run once on load, too
document.addEventListener("DOMContentLoaded", toggleMobileSubscriptionChecklist);

function updateSellingPlan() {
  const bundleBlock = getBundleBlock();
  const activeWrap = bundleBlock.querySelector('.lsg-bundle-interval-select-wrap[data-active="true"]');

  if (activeWrap) {
    const frequencySelect = activeWrap.querySelector(".lsg-bundle-interval-frequency-select");
    if (frequencySelect) {
      // Store the selling plan value as a data attribute instead of setting the input value
      activeWrap.dataset.currentSellingPlan = frequencySelect.value;
    }
  }
}

function inputChangeSubProduct(trigger) {
  //validates quantities for bundle products when the input field is updated
  if (isNaN(trigger.value) || trigger.value == "") {
    trigger.value = 0;
  }

  const newValue = parseInt(trigger.value);
  const oldValue = parseInt(trigger.defaultValue) || 0;

  // Check if the new value would exceed the current bundle size
  const currentCount = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);
  const currentBundle = document.querySelector('.bundle-option input[name="label"]:checked');

  if (currentBundle) {
    const currentBundleSize = parseInt(
      currentBundle.closest(".bundle-option").querySelector(".panel-body").textContent,
    );
    const countAfterChange = currentCount - oldValue + newValue;

    // If the new value would exceed the current bundle size
    if (countAfterChange > currentBundleSize) {
      // Find the next larger bundle size
      const bundleOptions = Array.from(document.querySelectorAll('.bundle-option input[name="label"]'))
        .map((radio) => ({
          radio,
          size: parseInt(radio.closest(".bundle-option").querySelector(".panel-body").textContent),
        }))
        .sort((a, b) => a.size - b.size);

      const nextBundle = bundleOptions.find((opt) => opt.size >= countAfterChange);
      if (nextBundle) {
        nextBundle.radio.click();
      }
    }
  }

  // Now apply the validated value
  if (newValue > parseInt(trigger.max)) {
    trigger.value = parseInt(trigger.max);
  }

  if (newValue < 0) {
    trigger.value = 0;
  }

  if (newValue < parseInt(trigger.min)) {
    trigger.value = parseInt(trigger.min);
  }

  trigger.defaultValue = trigger.value;
  updateQuantityDisplay(trigger);
  updateBundlePrice();
  updateBundleProgressDisplay();
}

function incrementSubProduct(trigger) {
  //validates quantities for the bundle products and updates the input when increment buttons are clicked
  const method = trigger.classList.contains("lsg-bundle-product-select-quantity-minus")
    ? "minus"
    : trigger.classList.contains("lsg-bundle-product-select-quantity-plus")
      ? "plus"
      : "";
  const input = trigger
    .closest(".lsg-bundle-product-select-quantity-wrap")
    .querySelector(".lsg-bundle-product-select-quantity-input");
  const bundleMax = trigger.closest(".lsg-bundle-product-set-list").dataset.bundleMax;
  const bundleQuantity = getBundleQuantity(trigger);

  switch (method) {
    case "plus":
      if (input.value >= parseInt(input.max)) {
        //reset to inventory max if over
        input.value = parseInt(input.max);
      } else {
        // Check if adding one more would exceed the current bundle size
        const currentCount = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);
        const currentBundle = document.querySelector('.bundle-option input[name="label"]:checked');

        if (currentBundle) {
          const currentBundleSize = parseInt(
            currentBundle.closest(".bundle-option").querySelector(".panel-body").textContent,
          );

          // If adding one more would exceed the current bundle size
          if (currentCount + 1 > currentBundleSize) {
            // Find the next larger bundle size
            const bundleOptions = Array.from(document.querySelectorAll('.bundle-option input[name="label"]'))
              .map((radio) => ({
                radio,
                size: parseInt(radio.closest(".bundle-option").querySelector(".panel-body").textContent),
              }))
              .sort((a, b) => a.size - b.size);

            const nextBundle = bundleOptions.find((opt) => opt.size > currentBundleSize);
            if (nextBundle) {
              nextBundle.radio.click();
            }
          }
        }

        // Now increment the value
        input.value++;
      }
      updateBundlePrice();
      break;
    case "minus":
      if (input.value <= parseInt(input.min)) {
        input.value = parseInt(input.min);
      } else if (input.value <= 0) {
        input.value = 0;
      } else {
        input.value--;
      }
      updateBundlePrice();
      break;
  }
  updateQuantityDisplay(input);
  mirrorQuantityDisplay(input);
  updateBundleProgressDisplay();
}

function mirrorQuantityDisplay(input) {
  const bundleBlock = getBundleBlock();
  const productID = input.dataset.product;
  const quantity = input.value;
  const productInputs = bundleBlock.querySelectorAll(
    '[data-product="' + productID + '"].lsg-bundle-product-select-quantity-input',
  );
  productInputs.forEach(function (productInput) {
    if (productInput !== input) {
      productInput.value = quantity;
      inputChangeSubProduct(productInput);
    }
  });
}

function updateQuantityDisplay(input) {
  const inputWrap = input.closest(".lsg-bundle-product-select-quantity-wrap");
  if (input.value <= 0) {
    inputWrap.classList.add("no-quantity");
  } else {
    inputWrap.classList.remove("no-quantity");
  }
  const inputDisplay = input.parentNode.querySelector(".lsg-bundle-product-select-quantity-input-display");
  if (inputDisplay) {
    inputDisplay.innerHTML = input.value;
  }
}

function updateBundleTracker() {
  const tracker = document.querySelector(".lsg-bundle-tracker-bar");
  if (!tracker) return;

  const fill = tracker.querySelector(".lsg-bundle-tracker-fill");
  console.log("Fill element:", fill);

  // Get milestones
  const milestones = Array.from(tracker.querySelectorAll(".lsg-bundle-tracker-option"))
    .map((el) => parseInt(el.textContent.trim(), 10))
    .sort((a, b) => a - b); // e.g., [0, 3, 6] or [0, 3, 6, 12]

  const max = milestones[milestones.length - 1]; // e.g., 6 or 12
  const count = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);

  // Find the milestone that 'count' has reached or exceeded, and the next milestone
  let reachedMilestone = 0;
  let nextMilestone = milestones[1]; // Start with the first milestone after 0
  for (let i = 0; i < milestones.length; i++) {
    if (count >= milestones[i]) {
      reachedMilestone = milestones[i];
      nextMilestone = milestones[i + 1] || max;
    } else {
      break;
    }
  }

  // Dynamically calculate circleWidthPercentage
  const barWidth = tracker.offsetWidth; // e.g., 300px
  const circleWidth = 36; // From CSS
  const circleWidthPercentage = barWidth > 0 ? (circleWidth / barWidth) * 100 : 0; // e.g., 12%

  // Calculate percentage with interpolation
  let percentage;
  if (count >= max) {
    percentage = 100; // Full progress
  } else if (count <= 0) {
    percentage = 0; // No progress
  } else if (reachedMilestone === 0 && count < nextMilestone) {
    // Special case: From 0 to first milestone
    const milestoneRange = nextMilestone; // e.g., 3
    const fraction = count / milestoneRange; // e.g., 1/3 = 0.3333 for count = 1
    const milestonePercentageEnd = (milestones.indexOf(nextMilestone) / (milestones.length - 1)) * 100; // e.g., 33.33% or 50%
    percentage = circleWidthPercentage + fraction * (milestonePercentageEnd - circleWidthPercentage);
  } else if (nextMilestone === max) {
    // Special case: Between second-to-last and last milestone
    const milestoneRange = nextMilestone - reachedMilestone;
    const progressInRange = count - reachedMilestone;
    const fraction = milestoneRange > 0 ? progressInRange / milestoneRange : 0;
    const milestonePercentageStart = (milestones.indexOf(reachedMilestone) / (milestones.length - 1)) * 100; // e.g., 66.67% or 50%
    const milestonePercentageEnd = 100 - circleWidthPercentage / 2; // Stop at the left edge of the last circle, e.g., 94%
    percentage = milestonePercentageStart + fraction * (milestonePercentageEnd - milestonePercentageStart);
  } else {
    // Normal interpolation between other milestones
    const milestoneRange = nextMilestone - reachedMilestone;
    const progressInRange = count - reachedMilestone;
    const fraction = milestoneRange > 0 ? progressInRange / milestoneRange : 0;
    const milestonePercentageStart = (milestones.indexOf(reachedMilestone) / (milestones.length - 1)) * 100;
    const milestonePercentageEnd = (milestones.indexOf(nextMilestone) / (milestones.length - 1)) * 100;
    percentage = milestonePercentageStart + fraction * (milestonePercentageEnd - milestonePercentageStart);
  }

  console.log(
    "Bar Width:",
    barWidth,
    "Circle Width %:",
    circleWidthPercentage,
    "Count:",
    count,
    "Max:",
    max,
    "Percentage:",
    percentage,
    "Reached:",
    reachedMilestone,
    "Next:",
    nextMilestone,
  );

  tracker.dataset.trackerCount = count;
  tracker.dataset.trackerTarget = max;

  if (fill) {
    fill.style.width = `${percentage}%`;
  }

  // Update tracker-option active state
  tracker.querySelectorAll(".lsg-bundle-tracker-option").forEach((el) => {
    const step = parseInt(el.textContent.trim(), 10);
    if (step === reachedMilestone) {
      el.classList.add("active");
    } else {
      el.classList.remove("active");
    }
  });

  // Add call to update progress display
  updateBundleProgressDisplay();
}

function updateBundlePrice() {
  const bundleBlock = getBundleBlock();
  const otpPriceEls = bundleBlock.querySelectorAll(".lsg-bundle-interval-otp-price");
  const subPriceEls = bundleBlock.querySelectorAll(".lsg-bundle-interval-sub-price");
  const curPriceEls = bundleBlock.querySelectorAll("[data-bundle-total]");
  const productList = bundleBlock.querySelector(".lsg-bundle-product-set-list");
  const activeWrap = bundleBlock.querySelector('.lsg-bundle-interval-select-wrap[data-active="true"]');
  const frequencySelect = activeWrap?.querySelector(".lsg-bundle-interval-frequency-select option:checked");
  const hasIntervalSelect = bundleBlock.classList.contains("lsg-bundle--has-interval-select");

  // Calculate base subtotal and quantity
  let baseSubtotal = 0;
  let bundleQuantity = 0;
  if (productList) {
    productList.querySelectorAll(".lsg-bundle-product-select-quantity-input").forEach((input) => {
      const quantity = parseInt(input.value) || 0;
      const price = parseInt(input.dataset.price) || 0;
      baseSubtotal += quantity * price;
      bundleQuantity += quantity;
    });
  }

  // OTP price is just the base subtotal (no need to add productBasePrice since it's 0)
  const otpSubtotal = baseSubtotal;
  let subSubtotal = otpSubtotal; // Start with OTP price for subscription

  // Apply subscription discount if applicable
  let perTubeDiscounted = 0;
  let perTubeSubPrice = 0;
  let totalSubPrice = 0;
  if (frequencySelect && hasIntervalSelect) {
    const discountType = frequencySelect.dataset.discountType;
    const discountValue = parseInt(frequencySelect.dataset.discountValue) || 0;
    const singleItemPrice = parseFloat(bundleBlock.closest(".lsg-bundle-wrapper").dataset.basePrice || 16);

    // Calculate per-tube price after bundle discount
    let fixedAmount = discountValue;
    if (discountType === "fixed_amount") {
      // If discountValue is in cents (e.g., 267), convert to dollars
      if (fixedAmount > singleItemPrice) {
        fixedAmount = fixedAmount / 100;
      }
    }
    if (discountType === "percentage") {
      perTubeDiscounted = singleItemPrice * (1 - discountValue / 100);
    } else if (discountType === "fixed_amount") {
      perTubeDiscounted = singleItemPrice - fixedAmount;
    } else {
      perTubeDiscounted = singleItemPrice;
    }
    // Apply 25% off to each tube, round to nearest cent, then sum
    perTubeSubPrice = Math.round(perTubeDiscounted * 0.75 * 100) / 100;
    totalSubPrice = perTubeSubPrice * bundleQuantity;
    subSubtotal = Math.round(totalSubPrice * 100); // for cents-based formatting below
  }

  // Format prices with a custom function to remove trailing zeros
  const formatPriceLsg = (cents) => {
    // Always round to nearest cent
    const roundedCents = Math.round(cents);
    const dollars = roundedCents / 100;
    // First format with standard currency formatter
    const formatted = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(dollars);

    // Then remove trailing zeros if they exist
    return formatted.endsWith(".00") ? formatted.slice(0, -3) : formatted;
  };

  // Update OTP and subscription prices
  otpPriceEls.forEach((el) => {
    el.innerHTML = formatPriceLsg(otpSubtotal);
  });
  subPriceEls.forEach((el) => {
    el.innerHTML = formatPriceLsg(subSubtotal);
  });

  // Update ATC button prices
  const subscribeOriginalPrice = document.querySelector("[data-subscribe-price-original]");
  const subscribeDiscountedPrice = document.querySelector("[data-subscribe-price-discounted]");
  const oneTimePurchasePrice = document.querySelector("[data-bundle-one-time-price]");

  if (subscribeOriginalPrice) {
    subscribeOriginalPrice.textContent = formatPriceLsg(otpSubtotal);
  }
  if (subscribeDiscountedPrice) {
    // Use the same per-tube rounding logic for the ATC button
    subscribeDiscountedPrice.textContent = formatPriceLsg(subSubtotal);
  }
  if (oneTimePurchasePrice) {
    oneTimePurchasePrice.textContent = formatPriceLsg(otpSubtotal);
  }
}

function initializePurchaseOptionSync() {
  const purchaseRadios = document.querySelectorAll('.row--purchase input[name="purchase"]');
  const bundleIntervalWraps = document.querySelectorAll(".lsg-bundle-interval-select-wrap");
  console.log(
    "initializePurchaseOptionSync: Purchase Radios:",
    purchaseRadios.length,
    "Bundle Wraps:",
    bundleIntervalWraps.length,
  );

  // Function to sync purchase radios with bundle interval
  function syncPurchaseToBundle(isSubscription) {
    const activeBundleWrap =
      document.querySelector('.lsg-bundle-interval-select-wrap[data-active="true"]') ||
      document.querySelector(".lsg-bundle-interval-select-wrap");
    if (!activeBundleWrap) {
      console.log("syncPurchaseToBundle: No active bundle wrap found");
      return;
    }

    const bundleIndex = Array.from(bundleIntervalWraps).indexOf(activeBundleWrap) + 1;
    const bundleSubRadio = document.getElementById(`bundleIntervalSelectSub_${bundleIndex}`);
    const bundleOTPRadio = document.getElementById(`bundleIntervalSelectOTP_${bundleIndex}`);
    console.log(
      "syncPurchaseToBundle: IsSubscription:",
      isSubscription,
      "Bundle Index:",
      bundleIndex,
      "Sub Radio:",
      !!bundleSubRadio,
      "OTP Radio:",
      !!bundleOTPRadio,
    );

    if (isSubscription && bundleSubRadio) {
      bundleSubRadio.checked = true;
      console.log("syncPurchaseToBundle: Setting Sub Radio checked");
      updateInterval(bundleSubRadio);
    } else if (!isSubscription && bundleOTPRadio) {
      bundleOTPRadio.checked = true;
      console.log("syncPurchaseToBundle: Setting OTP Radio checked");
      updateInterval(bundleOTPRadio);
    } else {
      console.log("syncPurchaseToBundle: No matching radio found for bundle index", bundleIndex);
    }
    checkoutEnableValidation();
  }

  // Sync bundle interval with purchase radios
  function syncBundleToPurchase(value) {
    const subscriptionRadio = document.querySelector(
      '.row--purchase input[name="purchase"]:not(.one-time-option input)',
    );
    const otpRadio = document.querySelector('.one-time-option input[name="purchase"]');
    console.log("syncBundleToPurchase: Value:", value, "Sub Radio:", !!subscriptionRadio, "OTP Radio:", !!otpRadio);

    if (value === "sub" && subscriptionRadio) {
      subscriptionRadio.checked = true;
      console.log("syncBundleToPurchase: Set subscription radio checked");
    } else if (value === "otp" && otpRadio) {
      otpRadio.checked = true;
      console.log("syncBundleToPurchase: Set OTP radio checked");
    }
  }

  // Initialize: Set bundle interval based on selected purchase radio
  const selectedPurchase = document.querySelector('.row--purchase input[name="purchase"]:checked');
  if (selectedPurchase) {
    const isSubscription = !selectedPurchase.closest(".one-time-option");
    console.log("initializePurchaseOptionSync: Initial Selected Purchase - IsSubscription:", isSubscription);
    syncPurchaseToBundle(isSubscription);
  } else {
    console.log("initializePurchaseOptionSync: No purchase radio selected");
  }

  // Event listeners for purchase radios
  purchaseRadios.forEach((radio) => {
    radio.addEventListener("change", function () {
      const isSubscription = !this.closest(".one-time-option");
      console.log("Purchase Radio Change: IsSubscription:", isSubscription);
      syncPurchaseToBundle(isSubscription);
    });
  });

  // Event listeners for bundle interval radios
  bundleIntervalWraps.forEach((wrap) => {
    const subRadio = wrap.querySelector('input[value="sub"]');
    const otpRadio = wrap.querySelector('input[value="otp"]');
    console.log("Bundle Wrap:", wrap.dataset.bundleProductId, "Sub Radio:", !!subRadio, "OTP Radio:", !!otpRadio);

    [subRadio, otpRadio].forEach((radio) => {
      if (!radio) return;
      radio.addEventListener("change", function () {
        console.log("Bundle Radio Change: Value:", this.value, "Is Active Wrap:", wrap.dataset.active === "true");
        if (wrap.dataset.active !== "true" && bundleIntervalWraps.length > 1) return;
        syncBundleToPurchase(this.value);
        updateInterval(this);
        checkoutEnableValidation();
      });
    });
  });
}

function initializeBundle() {
  const bundleBlock = document.querySelector(".lsg-bundle-block");
  if (!bundleBlock) {
    console.log("initializeBundle: No bundle block found");
    return;
  }

  const intervalSelect = bundleBlock.querySelector(".lsg-bundle-interval-select");
  const onlyOTP = bundleBlock.querySelector(".lsg-bundle-interval-only-otp");
  const onlySub = bundleBlock.querySelector(".lsg-bundle-interval-only-sub");
  const sellingPlanInput = bundleBlock.querySelector('.lsg-bundle-form input[name="selling_plan"]');
  const frequencySelect = bundleBlock.querySelector(".lsg-bundle-interval-frequency-select:not(.is-duplicate)");
  console.log(
    "initializeBundle: Interval Select:",
    !!intervalSelect,
    "Only OTP:",
    !!onlyOTP,
    "Only Sub:",
    !!onlySub,
    "Selling Plan Input:",
    !!sellingPlanInput,
    "Frequency Select:",
    !!frequencySelect,
  );

  // Initialize purchase option sync first
  initializePurchaseOptionSync();

  // Set bundle state based on purchase option sync
  if (intervalSelect) {
    bundleBlock.classList.add("lsg-bundle--has-interval-select");
    const selectedInterval =
      intervalSelect.querySelector('input[name^="bundle_interval_select_"]:checked') ||
      document.querySelector('input[name^="bundle_interval_select_"][value="otp"]');
    console.log("initializeBundle: Selected Interval:", selectedInterval?.value);
    if (selectedInterval?.value === "sub" && sellingPlanInput && frequencySelect) {
      bundleBlock.classList.add("lsg-bundle--sub-selected");
      sellingPlanInput.value = frequencySelect.value;
      console.log("initializeBundle: Set Sub selected, Selling Plan:", sellingPlanInput.value);
    } else {
      bundleBlock.classList.add("lsg-bundle--otp-selected");
      if (sellingPlanInput) sellingPlanInput.value = "";
      console.log("initializeBundle: Set OTP selected, Selling Plan:", sellingPlanInput.value);
    }
  } else if (onlyOTP) {
    bundleBlock.classList.add("lsg-bundle--only-otp");
    if (sellingPlanInput) sellingPlanInput.value = "";
    console.log("initializeBundle: Set Only OTP, Selling Plan:", sellingPlanInput.value);
  } else if (onlySub) {
    bundleBlock.classList.add("lsg-bundle--only-sub");
    if (sellingPlanInput && frequencySelect) sellingPlanInput.value = frequencySelect.value;
    console.log("initializeBundle: Set Only Sub, Selling Plan:", sellingPlanInput.value);
  }

  // Init quantity controls
  bundleBlock.querySelectorAll(".lsg-bundle-product-set-list").forEach((productSetList) => {
    // console.log('TEST', productSetList.querySelector('.lsg-bundle-product-select-quantity-input'))
    const quantityInput = productSetList.querySelector(".lsg-bundle-product-select-quantity-input");
    if (quantityInput) incrementEnableValidation(quantityInput);
  });

  // Load params before running validation
  checkParameter();

  // Ensure selling plan and UI are updated
  updateSellingPlan();
  checkoutEnableValidation();

  // Flag initialized
  setTimeout(() => {
    bundleBlock.classList.add("is-initialized");
    console.log("initializeBundle: Bundle block initialized");
  }, 500);

  // Add mobile summary initialization
  initializeMobileSummary();
}

function preselectProducts(variantIds, bundleSize) {
  console.log("Starting preselectProducts with:", { variantIds, bundleSize });
  console.log("Current selectedProducts:", selectedProducts);

  // First clear all current selections by simulating minus button clicks
  console.log("Clearing current selections...");

  // Force clear the selectedProducts array first
  selectedProducts.length = 0;

  // Clear all quantity inputs and update UI
  document.querySelectorAll("[data-lsg-bundle-variant-select-id]").forEach((productWrapper) => {
    const input = productWrapper.querySelector(".lsg-bundle-product-select-quantity-input");
    if (input) {
      input.value = "0";
      const inputWrap = input.closest(".lsg-bundle-product-select-quantity-wrap");
      if (inputWrap) {
        inputWrap.classList.add("no-quantity");
        // Reset disabled state
        const plusBtn = inputWrap.querySelector(".lsg-bundle-product-select-quantity-plus");
        const minusBtn = inputWrap.querySelector(".lsg-bundle-product-select-quantity-minus");
        if (plusBtn) plusBtn.disabled = false;
        if (minusBtn) minusBtn.disabled = true;
      }
    }
  });

  // Reset bundle state
  const bundleBlock = getBundleBlock();
  if (bundleBlock) {
    bundleBlock.classList.remove("bundle-max-reached");
    bundleBlock.classList.remove("bundle-checkout-enabled");
  }

  // Update UI to reflect cleared state
  updateSelectedProductGUI();
  updateBundleTracker();
  checkoutEnableValidation();

  // Now add each product from the preset
  console.log("Adding preset products...");
  variantIds.forEach((variantId) => {
    console.log("Processing variant:", variantId);
    // Check if we've reached the bundle size limit
    const currentTotal = selectedProducts.reduce((sum, p) => sum + (p.quantity || 1), 0);
    console.log("Current total selected:", currentTotal);

    if (currentTotal >= bundleSize) {
      console.log("Bundle size limit reached, skipping remaining variants");
      return;
    }

    const productWrapper = document.querySelector(`[data-lsg-bundle-variant-select-id="${variantId}"]`);
    console.log("Found product wrapper:", !!productWrapper);

    if (productWrapper) {
      const plusBtn = productWrapper.querySelector(".lsg-bundle-product-select-quantity-plus");
      console.log("Found plus button:", !!plusBtn);

      if (plusBtn) {
        console.log("Clicking plus button for variant:", variantId);
        plusBtn.click();
      }
    }
  });

  console.log("Final selectedProducts:", selectedProducts);

  // Update all necessary UI elements
  updateBundleTracker();
  checkoutEnableValidation();
  updateUpsellMessage();
}

// Initialize preset bundle buttons
function initializePresetBundles() {
  console.log("Initializing preset bundles...");
  const presetButtons = document.querySelectorAll(".preset-bundle-button");
  const bundleRadios = document.querySelectorAll('.bundle-option input[name="label"]');
  const bannerButton = document.querySelector("[data-add-best-sellers-presset]");

  console.log("Found preset buttons:", presetButtons.length);
  console.log("Found bundle radios:", bundleRadios.length);
  console.log("Found banner button:", !!bannerButton);

  // Function to handle preset bundle removal
  function handlePresetBundleRemove(e) {
    e.preventDefault();
    e.stopPropagation();

    const button = e.target.closest(".preset-bundle-button");
    if (!button) return;

    // Clear all current selections
    const currentProducts = [...selectedProducts];
    currentProducts.forEach((product) => {
      const productWrapper = document.querySelector(
        `[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"]`,
      );
      if (productWrapper) {
        const minusBtn = productWrapper.querySelector(".lsg-bundle-product-select-quantity-minus");
        if (minusBtn) {
          for (let i = 0; i < product.quantity; i++) {
            minusBtn.click();
          }
        }
      }
    });

    // Remove active state from button
    button.classList.remove("active");
  }

  // Add click handlers to remove buttons
  document.querySelectorAll(".preset-bundle-button").forEach((button) => {
    const removeSpan = button.querySelector(".preset-bundle-remove");
    if (removeSpan) {
      removeSpan.addEventListener("click", handlePresetBundleRemove);
    }
  });

  // Function to trigger best sellers preset for current bundle size
  function triggerBestSellersPreset() {
    // Get current bundle size
    const activeBundle = document.querySelector('.bundle-option input[name="label"]:checked');
    if (!activeBundle) {
      console.log("No bundle size selected");
      return;
    }

    const bundleSize = parseInt(activeBundle.dataset.bundleCount);
    console.log("Current bundle size:", bundleSize);

    // Find the best sellers preset button for this size
    const bestSellersButton = document.querySelector(
      `.preset-bundles-button-wrapper[data-preset-bundles-count="${bundleSize}"] .preset-bundle-button[data-preset-best-sellers="true"]`,
    );

    if (bestSellersButton) {
      console.log("Found best sellers button for size:", bundleSize);
      bestSellersButton.click();
    } else {
      console.log("No best sellers preset found for bundle size:", bundleSize);
    }
  }

  // Add click handler to banner button
  if (bannerButton) {
    bannerButton.addEventListener("click", function (e) {
      e.preventDefault();
      console.log("Banner button clicked");
      triggerBestSellersPreset();
    });
  }

  // Function to show/hide preset button wrappers based on bundle size
  function updatePresetButtonVisibility(bundleSize) {
    console.log("Updating preset button visibility for size:", bundleSize);
    document.querySelectorAll(".preset-bundles-button-wrapper").forEach((wrapper) => {
      const isActive = wrapper.dataset.presetBundlesCount === bundleSize.toString();
      console.log("Wrapper:", wrapper.dataset.presetBundlesCount, "Active:", isActive);
      wrapper.classList.toggle("active", isActive);
    });
  }

  // Add change listener to bundle size radios
  bundleRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      const bundleSize = parseInt(e.target.dataset.bundleCount);
      console.log("Bundle radio changed:", bundleSize);
      updatePresetButtonVisibility(bundleSize);
    });
  });

  // Add click handlers to preset buttons
  presetButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      console.log("Preset button clicked:", button.textContent.trim());

      // Remove active class from all buttons in the same wrapper
      const buttonWrapper = button.closest(".preset-bundles-button-wrapper");
      buttonWrapper.querySelectorAll(".preset-bundle-button").forEach((btn) => {
        btn.classList.remove("active");
      });

      // Add active class to clicked button
      button.classList.add("active");

      // Get the bundle size from the wrapper
      const bundleSize = parseInt(buttonWrapper.dataset.presetBundlesCount);
      console.log("Bundle size from wrapper:", bundleSize);

      // Get variant IDs from the appropriate data attribute
      const variantIdsString = button.getAttribute(`data-bundle-${bundleSize}`);
      console.log("Button data attributes:", button.dataset);
      console.log("Direct attribute value:", button.getAttribute(`data-bundle-${bundleSize}`));

      if (variantIdsString) {
        const variantIds = variantIdsString.split("|");
        console.log("Split variant IDs:", variantIds);
        preselectProducts(variantIds, bundleSize);
      } else {
        console.error("No variant IDs found for bundle size:", bundleSize);
        console.log("Button element:", button.outerHTML);
      }
    });
  });

  // Initialize visibility based on default selected bundle size
  const defaultBundle = document.querySelector('.bundle-option input[name="label"]:checked');
  if (defaultBundle) {
    const bundleSize = parseInt(defaultBundle.dataset.bundleCount);
    console.log("Initializing with default bundle size:", bundleSize);
    updatePresetButtonVisibility(bundleSize);
  }
}

function getBundleQuantity() {
  //gets the quantity of the current active bundle block product list
  let bundleBlock = getBundleBlock();
  let quantity = -1;
  let productList = bundleBlock.querySelector(".lsg-bundle-product-set-list");
  if (productList) {
    quantity = 0;
    productList.querySelectorAll(".lsg-bundle-product-select-quantity-input").forEach(function (input) {
      quantity = quantity + parseInt(input.value);
    });
  }
  return quantity;
}

function getBundleQuantityByChild(trigger) {
  const productSetList = trigger.closest(".lsg-bundle-product-set-list");
  let quantity = 0;
  if (productSetList) {
    quantity = 0;
    productSetList.querySelectorAll(".lsg-bundle-product-select-quantity-input").forEach(function (input) {
      quantity = quantity + parseInt(input.value);
    });
  }
  return quantity;
}

function getBundleInterval() {
  //checks if the bundle is set to display OTP or suscription options
  let bundleBlock = getBundleBlock();
  if (bundleBlock.classList.contains("lsg-bundle--has-interval-select")) {
    if (bundleBlock.classList.contains("lsg-bundle--otp-selected")) {
      return "otp";
    }
    if (bundleBlock.classList.contains("lsg-bundle--sub-selected")) {
      return "sub";
    }
  }
  if (bundleBlock.classList.contains("lsg-bundle--only-otp")) {
    return "otp";
  }
  if (bundleBlock.classList.contains("lsg-bundle--only-sub")) {
    return "sub";
  }
  return "err";
}

function getBundleBlock() {
  return document.querySelector(".lsg-bundle-block");
}

function getGuid() {
  let d = new Date().getTime();
  let d2 = (performance && performance.now && performance.now() * 1000) || 0;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    let r = Math.random() * 16;
    if (d > 0) {
      r = ((d + r) % 16) | 0;
      d = Math.floor(d / 16);
    } else {
      r = ((d2 + r) % 16) | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c == "x" ? r : (r & 0x7) | 0x8).toString(16);
  });
}

document.querySelectorAll("[data-bundle-builder-selected-product-remove-button]").forEach(function (removeButton) {
  removeButton.addEventListener("click", function (e) {
    e.preventDefault();
    const wrapper = e.currentTarget.closest("[data-bundle-builder-selected-variant-id]");
    if (!wrapper) return;

    const variantID = wrapper.getAttribute("data-bundle-builder-selected-variant-id");
    const bundleProduct = document.querySelector(`[data-lsg-bundle-variant-select-id='${variantID}']`);
    const minusBtn = bundleProduct?.querySelector(".lsg-bundle-product-select-quantity-minus");
    if (minusBtn) minusBtn.click();
  });
});

document.querySelectorAll(".lsg-bundle-product-select-quantity-increment").forEach(function (incrementButton) {
  incrementButton.addEventListener("click", function (e) {
    e.preventDefault();
    incrementSubProduct(e.currentTarget);
    buildSelectedProductArray(e.currentTarget);
    incrementEnableValidation(e.currentTarget);
    checkoutEnableValidation();
    updateUpsellMessage();
    setUrl(e.currentTarget);
  });
});
document.querySelectorAll(".lsg-bundle-product-select-quantity-input").forEach(function (input) {
  input.addEventListener("change", function (e) {
    inputChangeSubProduct(e.currentTarget);
    incrementEnableValidation(e.currentTarget);
    checkoutEnableValidation();
    updateUpsellMessage();
  });
});
document
  .querySelectorAll('.lsg-bundle-interval-select input[name^="bundle_interval_select_"]')
  .forEach(function (intervalSelector) {
    intervalSelector.addEventListener("change", function (e) {
      updateInterval(e.currentTarget);
      checkoutEnableValidation();
      updateUpsellMessage();
      setUrl(e.currentTarget);
    });
  });
document.querySelectorAll(".lsg-bundle-interval-frequency-select").forEach(function (frequencySelect) {
  frequencySelect.addEventListener("change", function (e) {
    const trigger = e.currentTarget;
    updateFrequency(e.currentTarget);
    setUrl(e.currentTarget);
  });
});
const bundleATC = document.querySelector("[data-lsg-bundle-atc]");
if (bundleATC) {
  bundleATC.addEventListener("click", function (e) {
    e.preventDefault();
    if (e.currentTarget.classList.contains("disabled")) {
      const announcementOffset = parseInt(document.body.style.getPropertyValue("--announcement-offset")) || 0;
      const headerOffset = parseInt(document.body.style.getPropertyValue("--header-offset")) || 0;
      const offset = announcementOffset + headerOffset;
      const bundleBlock = getBundleBlock();
      window.scrollTo({ top: bundleBlock.offsetTop - offset, behavior: "smooth" });
    } else {
      // --- Ensure correct purchase radio is triggered ---
      const selectedPurchaseRadio = document.querySelector('.section--monthly-box input[name="purchase"]:checked');
      if (selectedPurchaseRadio) {
        selectedPurchaseRadio.click();
        const event = new Event("change", { bubbles: true });
        selectedPurchaseRadio.dispatchEvent(event);
      }
      // Always add as subscription
      addToCart(false);
    }
  });
}
document.querySelectorAll(".lsg-bundle-size-select-el").forEach(function (bundleSelector) {
  bundleSelector.addEventListener("click", function (e) {
    e.preventDefault();
    setActiveBundle(e.currentTarget);
  });
});

//Run initialize
initializeBundle();

const bundleObserver = new IntersectionObserver(([entry]) => {
  const bundleBlock = entry.target.closest(".lsg-bundle-block");
  if (bundleBlock) {
    bundleBlock.classList.remove("summary-is-below");
    bundleBlock.classList.remove("summary-is-above");
    bundleBlock.classList.remove("summary-is-visible");

    if (entry.isIntersecting) {
      // is visible
      bundleBlock.classList.add("summary-is-visible");
      return;
    } else if (entry.boundingClientRect.top > 0) {
      // item is below view
      bundleBlock.classList.add("summary-is-below");
    } else {
      // item is above view
      bundleBlock.classList.add("summary-is-above");
    }
  }
});
const buyboxes = document.querySelectorAll(".lsg-bundle-summary-block");
buyboxes.forEach((buybox) => {
  bundleObserver.observe(buybox);
});

const bottomObserver = new IntersectionObserver(
  ([entry]) => {
    const bundleBlocks = document.querySelectorAll(".lsg-bundle-block");
    if (entry.isIntersecting) {
      bundleBlocks.forEach((bundleBlock) => {
        bundleBlock.classList.add("is-scroll-bottom");
      });
    } else {
      bundleBlocks.forEach((bundleBlock) => {
        bundleBlock.classList.remove("is-scroll-bottom");
      });
    }
  },
  {
    threshold: 1,
  },
);
const subFooter = document.querySelector(".io-sub-footer");
if (subFooter) {
  bottomObserver.observe(subFooter);
}

function updateBundleProgressDisplay() {
  const bundleBlock = getBundleBlock();
  if (!bundleBlock) {
    return;
  }

  // Get the current count of selected products
  const count = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);

  // Get current bundle size from radio buttons
  const selectedRadio = document.querySelector('.bundle-option input[name="label"]:checked');
  const bundleSize = selectedRadio
    ? parseInt(selectedRadio.closest(".bundle-option").querySelector(".panel-body").textContent)
    : 6; // Default to 6 if no radio selected

  // Get all valid bundle sizes from tracker
  const tracker = document.querySelector(".lsg-bundle-tracker-bar");
  const validBundleSizes = Array.from(tracker?.querySelectorAll(".lsg-bundle-tracker-option") || [])
    .map((el) => parseInt(el.textContent.trim(), 10))
    .filter((size) => !isNaN(size) && size > 0) // Ensure we only include positive numbers
    .sort((a, b) => a - b);

  // Check if current count is a valid bundle size (and not zero)
  const isValidBundleSize = count > 0 && validBundleSizes.includes(count);

  // Update progress counts and display states for both summaries
  const updateSummaryDisplay = (summary) => {
    if (!summary) return;

    const notFullDisplay = summary.querySelector(".lsg-bundle-buybox-bundle-not-full");
    const fullDisplay = summary.querySelector(".lsg-bundle-buybox-bundle-full");
    const upsellIcons = summary.querySelector(".lsg-bundle-buybox-upsell-icons");

    if (notFullDisplay && fullDisplay) {
      // Update all progress count displays
      const progressCounts = summary.querySelectorAll("[data-progress-count]");
      progressCounts.forEach((countDisplay) => {
        countDisplay.textContent = `${count}/${bundleSize}`;
      });

      // Show/hide appropriate display based on whether we've hit a valid bundle size
      if (isValidBundleSize) {
        notFullDisplay.style.display = "none";
        fullDisplay.style.display = "flex";
        if (upsellIcons) {
          upsellIcons.style.display = "flex";
        }
      } else {
        notFullDisplay.style.display = "flex";
        fullDisplay.style.display = "none";
        if (upsellIcons) {
          upsellIcons.style.display = "none";
        }
      }
    }
  };

  // Update both summaries
  const mobileSummaryBlock = document.querySelector("[data-mobile-summary] .lsg-bundle-buybox-block");
  const desktopSummaryBlock = document.querySelector(
    ".lsg-bundle-summary-block .lsg-bundle-buybox-block.summary-block",
  );

  if (mobileSummaryBlock) {
    updateSummaryDisplay(mobileSummaryBlock);
  }
  if (desktopSummaryBlock) {
    updateSummaryDisplay(desktopSummaryBlock);
  }

  // Update the bundle tracker count
  if (tracker) {
    tracker.dataset.trackerCount = count;
    tracker.dataset.trackerTarget = bundleSize;
  }
}

// Add event listener for bundle size radio buttons
document.addEventListener("DOMContentLoaded", () => {
  const bundleSizeRadios = document.querySelectorAll('.bundle-option input[name="label"]');
  bundleSizeRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      // Prevent the default radio selection behavior if bundle is too large
      e.preventDefault();

      console.log("Bundle size radio changed");

      // Get the new bundle size from the selected radio button
      const newBundleSize = parseInt(e.target.closest(".bundle-option").querySelector(".panel-body").textContent);

      // Update the flavor selection text
      updateFlavorSelectionText(newBundleSize);

      // Get current selected quantity
      const currentCount = selectedProducts.reduce((total, p) => total + (p.quantity || 1), 0);

      // Check if we need to handle excess items
      if (currentCount > newBundleSize) {
        // Check if auto-remove is enabled
        const monthlyBox = document.querySelector(".section--monthly-box");
        const autoRemoveEnabled = monthlyBox?.dataset.autoRemoveExcess === "true";

        if (autoRemoveEnabled) {
          // Auto-remove excess items
          const excessCount = currentCount - newBundleSize;
          let remainingToRemove = excessCount;

          // Create a copy of selectedProducts to iterate over
          const products = [...selectedProducts].reverse(); // Start removing from most recently added

          for (const product of products) {
            if (remainingToRemove <= 0) break;

            const productWrapper = document.querySelector(
              `[data-lsg-bundle-variant-select-id="${product.selectedVariantId}"]`,
            );
            if (productWrapper) {
              const minusBtn = productWrapper.querySelector(".lsg-bundle-product-select-quantity-minus");
              if (minusBtn) {
                // Remove either all of this product's quantity or just what we need
                const removeCount = Math.min(product.quantity, remainingToRemove);
                for (let i = 0; i < removeCount; i++) {
                  minusBtn.click();
                }
                remainingToRemove -= removeCount;
              }
            }
          }

          // Allow the selection to proceed
          e.target.checked = true;

          // Update the display
          updateBundleProgressDisplay();
        } else {
          // Show the warning popup
          // const modal = document.getElementById('bundle-count-change-modal');
          // modal.querySelector('[data-selected-bundle-size]').textContent = newBundleSize;
          // modal.querySelector('[data-remove-count]').textContent = currentCount - newBundleSize;

          // Show the modal
          // const bsModal = new bootstrap.Modal(modal);
          // bsModal.show();

          // Keep the previous radio button selected
          e.target.checked = false;
          const currentSize = Math.max(
            ...Array.from(document.querySelectorAll(".lsg-bundle-tracker-option"))
              .map((el) => parseInt(el.textContent.trim(), 10))
              .filter((size) => size >= currentCount),
          );

          const previousRadio = document.querySelector(`.bundle-option input[name="label"][value="${currentSize}"]`);
          if (previousRadio) {
            previousRadio.checked = true;
          }
        }
      } else {
        // Allow the selection to proceed
        e.target.checked = true;

        // Update progress count displays
        const progressCounts = document.querySelectorAll("[data-progress-count]");
        progressCounts.forEach((countDisplay) => {
          countDisplay.textContent = `${currentCount}/${newBundleSize}`;
        });

        // Update the display
        updateBundleProgressDisplay();
      }
    });
  });
});

// Add these utility functions at the top level
function lockScroll() {
  // Store current scroll position
  const scrollY = window.scrollY;

  // Add styles to prevent scrolling while maintaining position
  document.body.style.position = "fixed";
  document.body.style.width = "100%";
  document.body.style.top = `-${scrollY}px`;
  // Store the scroll position to restore later
  document.body.dataset.scrollPosition = scrollY;
}

function unlockScroll() {
  // Get the scroll position first
  const scrollY = parseInt(document.body.dataset.scrollPosition || "0");

  // Remove the fixed position and scroll blocking styles
  document.body.style.position = "";
  document.body.style.width = "";
  document.body.style.top = "";

  // Force instant scroll without smooth behavior
  window.scrollTo({
    top: scrollY,
    left: 0,
    behavior: "instant", // Force instant jump to position
  });
  document.body.dataset.scrollPosition = "";
}

function initializeMobileSummary() {
  const mobileSummaryTriggers = document.querySelectorAll("[mobile-summary-open]");
  const summaryBlock = document.querySelector(".lsg-bundle-summary-block");
  const selectedProducts = document.querySelector(".bundle-builder__selected-products");
  const closeButton = document.querySelector(".lsg-bundle-buybox-close-summary");
  const bundleBlock = document.querySelector(".lsg-bundle-block");

  if (!mobileSummaryTriggers.length || !summaryBlock || !selectedProducts) {
    return;
  }

  window.mobileSummaryActiveTrigger = null;

  const closeSummary = () => {
    summaryBlock.classList.remove("open");
    if (bundleBlock) {
      bundleBlock.classList.remove("mobile-bundle-drawer--opened");
    }
    const activeTrigger = document.querySelector("[mobile-summary-open].active");
    if (activeTrigger) {
      activeTrigger.classList.remove("active");
    }
    window.mobileSummaryActiveTrigger = null;
    unlockScroll();
  };

  // Close on escape key
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && summaryBlock.classList.contains("open")) {
      closeSummary();
    }
  });

  // Close button handler
  if (closeButton) {
    closeButton.addEventListener("click", (event) => {
      event.stopPropagation(); // Prevent event bubbling
      closeSummary();
    });
  }

  // Trigger button handlers
  mobileSummaryTriggers.forEach((trigger) => {
    // Remove any existing click listeners first
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);

    newTrigger.addEventListener("click", (event) => {
      console.log("Trigger clicked");
      event.preventDefault();
      event.stopPropagation();
      handleTriggerActivation(newTrigger, event);
    });

    newTrigger.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        console.log("Trigger keydown:", event.key);
        event.preventDefault();
        event.stopPropagation();
        handleTriggerActivation(newTrigger, event);
      }
    });
  });

  // Handle auto-close when count reaches zero
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "style") {
        const count = selectedProducts.querySelectorAll(".bundle-builder__selected-product").length;
        if (count === 0 && summaryBlock.classList.contains("open")) {
          closeSummary(); // This will properly close the summary and unlock scrolling
        }
      }
    });
  });

  observer.observe(selectedProducts, { attributes: true, childList: true, subtree: true });

  // Add a direct observer for product removals
  const productObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
        const count = selectedProducts.querySelectorAll(".bundle-builder__selected-product").length;
        if (count === 0 && summaryBlock.classList.contains("open")) {
          closeSummary(); // This will properly close the summary and unlock scrolling
        }
      }
    });
  });

  productObserver.observe(selectedProducts, { childList: true });
}

// Handle trigger activation
const handleTriggerActivation = (trigger, event) => {
  event.preventDefault();
  event.stopPropagation();

  const summaryBlock = document.querySelector(".lsg-bundle-summary-block");
  const bundleBlock = document.querySelector(".lsg-bundle-block");

  if (!summaryBlock || !bundleBlock) {
    console.log("Missing required elements in handleTriggerActivation");
    return;
  }

  if (window.mobileSummaryActiveTrigger === trigger) {
    // Closing
    summaryBlock.classList.remove("open");
    bundleBlock.classList.remove("mobile-bundle-drawer--opened");
    trigger.classList.remove("active");
    window.mobileSummaryActiveTrigger = null;
    unlockScroll();
    return;
  }

  // Opening
  if (window.mobileSummaryActiveTrigger) {
    window.mobileSummaryActiveTrigger.classList.remove("active");
  }

  trigger.classList.add("active");
  window.mobileSummaryActiveTrigger = trigger;
  summaryBlock.classList.add("open");
  bundleBlock.classList.add("mobile-bundle-drawer--opened");
  lockScroll();
};

// Maintain mobile drawer state during viewport changes
let mobileDrawerStateTimeout;
window.addEventListener("resize", () => {
  if (mobileDrawerStateTimeout) {
    clearTimeout(mobileDrawerStateTimeout);
  }
  mobileDrawerStateTimeout = setTimeout(() => {
    // Keep the mobile drawer state in sync
    if (document.querySelector(".lsg-bundle-summary-block.open")) {
      const bundleBlock = document.querySelector(".lsg-bundle-block");
      if (bundleBlock) {
        bundleBlock.classList.add("mobile-bundle-drawer--opened");
      }
    }
  }, 250);
});

// Add event listener for one-time purchase button
const oneTimePurchaseButton = document.getElementById("bundle-atc--one-time-purchase");
if (oneTimePurchaseButton) {
  oneTimePurchaseButton.addEventListener("click", function (e) {
    e.preventDefault();
    if (!e.currentTarget.classList.contains("disabled")) {
      // --- Ensure correct purchase radio is triggered ---
      const selectedPurchaseRadio = document.querySelector('.section--monthly-box input[name="purchase"]:checked');
      if (selectedPurchaseRadio) {
        selectedPurchaseRadio.click();
        const event = new Event("change", { bubbles: true });
        selectedPurchaseRadio.dispatchEvent(event);
      }
      // Always add as one-time purchase
      addToCart(true);
    } else {
      const announcementOffset = parseInt(document.body.style.getPropertyValue("--announcement-offset")) || 0;
      const headerOffset = parseInt(document.body.style.getPropertyValue("--header-offset")) || 0;
      const offset = announcementOffset + headerOffset;
      const bundleBlock = getBundleBlock();
      window.scrollTo({ top: bundleBlock.offsetTop - offset, behavior: "smooth" });
    }
  });
}

// Function to update prices when bundle selection changes
function updateBundlePrices(selectedBundle) {
  const bundleCount = parseInt(selectedBundle.dataset.bundleCount);
  const discountAmount = parseFloat(selectedBundle.dataset.discountAmount) || 0;
  const discountType = selectedBundle.dataset.bundlePriceType;
  const bundleBlock = getBundleBlock();
  const singleItemPrice = parseFloat(bundleBlock.closest(".lsg-bundle-wrapper").dataset.basePrice || 16); // Get base price from data attribute, fallback to 16
  const totalOriginalPrice = singleItemPrice * bundleCount;

  // Format price consistently
  const formatPriceLsg = (price) => {
    // Always round to nearest cent
    const rounded = Math.round(price * 100) / 100;
    return `$${rounded.toFixed(2)}`;
  };

  // Only update the .row--purchase price area
  const rowPurchase = document.querySelector(".section--monthly-box .row--purchase");
  if (!rowPurchase) return;
  const originalPriceElement = rowPurchase.querySelector("[data-original-price]");
  const discountedPriceElement = rowPurchase.querySelector("[data-discounted-price]");
  const oneTimePriceElement = rowPurchase.querySelector(".one-time-option [data-original-price]");

  if (originalPriceElement && discountedPriceElement && oneTimePriceElement) {
    // Original price is always the undiscounted price
    const formattedOriginalPrice = formatPriceLsg(totalOriginalPrice);
    originalPriceElement.textContent = formattedOriginalPrice;
    oneTimePriceElement.textContent = formattedOriginalPrice;

    // Calculate discounted price per tube
    let perTubeDiscounted = singleItemPrice;
    if (discountAmount && discountAmount > 0) {
      if (discountType === "percentage") {
        perTubeDiscounted = singleItemPrice * (1 - discountAmount / 100);
      } else if (discountType === "fixed_amount") {
        perTubeDiscounted = singleItemPrice - discountAmount;
      }
    }
    // Apply 25% off to each tube, round to nearest cent, then sum
    let perTubeSubPrice = Math.round(perTubeDiscounted * 0.75 * 100) / 100;
    let totalSubPrice = perTubeSubPrice * bundleCount;
    discountedPriceElement.textContent = formatPriceLsg(totalSubPrice);
  }
}

// Initialize bundle price updates
function initializeBundlePrices() {
  const bundleRadios = document.querySelectorAll('.section--monthly-box input[name="label"]');

  // Add change listeners to bundle radios
  bundleRadios.forEach((radio) => {
    radio.addEventListener("change", (e) => {
      // Check if there's any validation logic that prevents the change
      const canChange = true; // This will be handled by the existing bundle validation logic

      if (canChange) {
        updateBundlePrices(e.target);
      } else {
        // If change is not allowed, revert to previous selection
        const previouslySelected = document.querySelector('input[name="label"][checked]');
        if (previouslySelected) {
          previouslySelected.checked = true;
        }
      }
    });
  });

  // Initialize prices with the default selected bundle
  const defaultBundle = document.querySelector('input[name="label"][checked]');
  if (defaultBundle) {
    updateBundlePrices(defaultBundle);
  }
}

// Add to the existing initialization
document.addEventListener("DOMContentLoaded", () => {
  initializeBundle();
  initializeBundlePrices();
  initializePresetBundles();
  if (window.lsgBundleActions) {
    window.dispatchEvent(new CustomEvent("lsgbundle:ready", { detail: window.lsgBundleActions }));
  }

  // Initialize flavor selection text with default bundle size
  const defaultBundle = document.querySelector('.bundle-option input[name="label"]:checked');
  if (defaultBundle) {
    const defaultSize = parseInt(defaultBundle.closest(".bundle-option").querySelector(".panel-body").textContent);
    updateFlavorSelectionText(defaultSize);
  }
});

function updateFlavorSelectionText(bundleSize) {
  // Get all flavor selection text elements
  const textElements = document.querySelectorAll(".lsg-bundle-buybox-product-name, .lsg-bundle-adding-message");

  textElements.forEach((element) => {
    // Skip elements that say "Review box or keep adding"
    if (element.textContent.trim() === "Review box or keep adding") {
      return;
    }

    const template = element.dataset.flavorSelectionText || "Choose [count] Flavors";
    element.textContent = template.replace("[count]", bundleSize);
  });
}

function filterProducts(selectedFlavor) {
  const productWrappers = document.querySelectorAll(".lsg-bundle-product-select-wrapper");
  const promoBanner = document.querySelector(".lsg-product--promo-banner");
  const brandOptions = document.querySelectorAll('[data-is-brand="true"]');

  // Handle brand group selection
  if (selectedFlavor === "All G.O.A.T. Foods Brands") {
    // Show all brand products and hide brand options
    brandOptions.forEach((opt) => (opt.style.display = "none"));
    productWrappers.forEach((wrapper) => {
      const flavorList = JSON.parse(wrapper.getAttribute("data-flavor-list") || "[]").map((f) => f.toLowerCase());
      const hasBrand = flavorList.some((f) => f.includes(".com"));
      wrapper.style.display = hasBrand ? "flex" : "none";
    });
  } else {
    // Show brand options if not in brand group view
    brandOptions.forEach((opt) => (opt.style.display = selectedFlavor === "All" ? "none" : "block"));

    // Handle regular filtering
    productWrappers.forEach((wrapper) => {
      const flavorList = JSON.parse(wrapper.getAttribute("data-flavor-list") || "[]").map((f) => f.toLowerCase());
      if (selectedFlavor.toLowerCase() === "all" || flavorList.includes(selectedFlavor.toLowerCase())) {
        wrapper.style.display = "flex";
      } else {
        wrapper.style.display = "none";
      }
    });
  }

  // Handle promo banner visibility
  if (promoBanner) {
    promoBanner.style.display = selectedFlavor.toLowerCase() === "all" ? "flex" : "none";
  }
}
/* ========= Global actions for other scripts (with capacity checks) ========= */

(function attachLsgBundleActions() {
  function getCurrentBundleSize() {
    // Prefer the radio’s visible size text (e.g., “6”) in your markup
    const selectedRadio = document.querySelector('.bundle-option input[name="label"]:checked');
    const sizeFromPanel = selectedRadio
      ? parseInt(selectedRadio.closest(".bundle-option").querySelector(".panel-body").textContent, 10)
      : NaN;

    if (!Number.isNaN(sizeFromPanel)) return sizeFromPanel;

    // Fallback to tracker’s max if present
    const tracker = document.querySelector(".lsg-bundle-tracker-bar");
    const trackerMax = tracker ? parseInt(tracker.dataset.bundleMax || tracker.dataset.trackerTarget, 10) : NaN;
    return !Number.isNaN(trackerMax) ? trackerMax : 6; // sensible default
  }

  function currentTotalSelected() {
    try {
      // you already declared this helper in your file:
      return typeof getTotalSelectedQuantity === "function"
        ? getTotalSelectedQuantity()
        : Array.isArray(window.selectedProducts)
          ? window.selectedProducts.reduce((s, p) => s + (p.quantity || 1), 0)
          : 0;
    } catch {
      return 0;
    }
  }

  function switchToNextBundleSize(minRequired) {
    const options = Array.from(document.querySelectorAll('.bundle-option input[name="label"]'))
      .map((radio) => ({
        radio,
        size: parseInt(radio.closest(".bundle-option").querySelector(".panel-body").textContent, 10),
      }))
      .filter((o) => !Number.isNaN(o.size))
      .sort((a, b) => a.size - b.size);

    const next = options.find((o) => o.size >= minRequired);
    if (next) {
      next.radio.click();
      // Let your existing listeners update prices/UI/etc.
      const ev = new Event("change", { bubbles: true });
      next.radio.dispatchEvent(ev);
      return next.size;
    }
    return null;
  }

  /**
   * Add up to `qty` tubes of the given variant.
   * - Respects: overall bundle remaining, per-variant input max, optional set-level max.
   * - Options:
   *    - autosize (default false): if true and not enough room, switch to the next bundle that fits.
   * @returns {number} how many were actually added
   */
  function addTube(variantId, qty = 1, { autosize = false } = {}) {
    const id = String(variantId);
    const wrapper = document.querySelector(`[data-lsg-bundle-variant-select-id="${id}"]`);
    if (!wrapper) {
      console.warn("[lsgBundleActions.addTube] variant not found:", id);
      return 0;
    }

    const plusBtn = wrapper.querySelector(".lsg-bundle-product-select-quantity-plus");
    const input = wrapper.querySelector(".lsg-bundle-product-select-quantity-input");
    if (!plusBtn || !input) return 0;

    // Current counts/limits
    const bundleSize = getCurrentBundleSize();
    const totalNow = currentTotalSelected();
    const overallRemaining = Math.max(0, bundleSize - totalNow);

    const curQty = parseInt(input.value || "0", 10);
    const maxPerVariant = parseInt(input.max || "9999", 10);
    const perVariantRemaining = Math.max(0, maxPerVariant - curQty);

    // Optional: set-level cap (if your list uses data-bundle-max)
    const productSetList = wrapper.closest(".lsg-bundle-product-set-list");
    const setMax = parseInt(productSetList?.dataset.bundleMax || "0", 10); // 0 = no cap
    let setRemaining = Infinity;
    if (setMax > 0) {
      // reuse your helper if available
      const inSetNow =
        typeof getBundleQuantityByChild === "function"
          ? getBundleQuantityByChild(plusBtn)
          : Array.from(productSetList.querySelectorAll(".lsg-bundle-product-select-quantity-input")).reduce(
              (s, el) => s + parseInt(el.value || "0", 10),
              0,
            );
      setRemaining = Math.max(0, setMax - inSetNow);
    }

    // How many can we add without violating limits?
    let allowable = Math.min(qty, overallRemaining, perVariantRemaining, setRemaining);

    // Optionally autosize up if we don't have enough room
    if (allowable < qty && autosize) {
      const neededTotal = totalNow + qty;
      const switchedTo = switchToNextBundleSize(neededTotal);
      if (switchedTo) {
        const newRemaining = Math.max(0, switchedTo - totalNow);
        allowable = Math.min(qty, newRemaining, perVariantRemaining, setRemaining);
      }
    }

    if (allowable <= 0) {
      // no room — fail fast without attempting clicks
      return 0;
    }

    // Add the allowable quantity using your existing flows
    for (let i = 0; i < allowable; i++) {
      incrementSubProduct(plusBtn);
      buildSelectedProductArray(plusBtn);
      incrementEnableValidation(plusBtn);
    }

    // Final passes like your normal click handler does
    checkoutEnableValidation();
    updateUpsellMessage?.();
    updateBundleTracker?.();
    updateBundleProgressDisplay?.();
    setUrl?.(plusBtn);

    return allowable;
  }

  function removeTube(variantId, qty = 1) {
    const id = String(variantId);
    const wrapper = document.querySelector(`[data-lsg-bundle-variant-select-id="${id}"]`);
    if (!wrapper) return 0;
    const minusBtn = wrapper.querySelector(".lsg-bundle-product-select-quantity-minus");
    const input = wrapper.querySelector(".lsg-bundle-product-select-quantity-input");
    if (!minusBtn || !input) return 0;

    const curQty = parseInt(input.value || "0", 10);
    const allowable = Math.min(qty, curQty);
    if (allowable <= 0) return 0;

    for (let i = 0; i < allowable; i++) {
      incrementSubProduct(minusBtn);
      buildSelectedProductArray(minusBtn);
      incrementEnableValidation(minusBtn);
    }

    checkoutEnableValidation();
    updateUpsellMessage?.();
    updateBundleTracker?.();
    updateBundleProgressDisplay?.();
    setUrl?.(minusBtn);

    return allowable;
  }

  function getSelected() {
    return Array.isArray(window.selectedProducts) ? window.selectedProducts.map((p) => ({ ...p })) : [];
  }
  function getCount() {
    return currentTotalSelected();
  }

  window.lsgBundleActions = { addTube, removeTube, getSelected, getCount };
  window.dispatchEvent(new CustomEvent("lsgbundle:ready", { detail: window.lsgBundleActions }));
})();
